import CurrentServices from "./current-service";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-[22px] font-normal text-[#1E2F65]">Services</h3>
        <CurrentServices />
      </div>
    </div>
  );
};

export default Offers;
